<template>
  <v-system-bar app height="48" class="pa-0">
    <v-app-bar height="48" clipped-left color="white" elevation="2">
      <!-- <router-link to="/"> -->
        <v-img
          class="mx-2 board-logo"
          src="../../../src/assets/images/TRINITY-BOARD-LOGO_RGB_LOGO_horizontal.svg"
          max-height="32"
          max-width="178"
          contain
          @click="goHome()"
        ></v-img>
      <!-- </router-link> -->
      <div v-if="!isMobile" style="display: contents">
        <jump-to-meeting v-if="$auth.isAuthenticated"></jump-to-meeting>
        <v-spacer></v-spacer>
        <global-search-text :key="$route.path" v-if="$auth.isAuthenticated"></global-search-text>
        <user-menu
          v-if="$auth.isAuthenticated"
          :userInfo="userInfo"
        ></user-menu>
        <tenant-selector v-if="$auth.isAuthenticated"></tenant-selector>
        <language-selector></language-selector>
        <help></help>
      </div>
      <!-- <v-icon v-if="isMobile" class="mr-5"
        >mdi-dots-vertical</v-icon
      > -->
      <!-- <v-spacer v-if="isMobile"></v-spacer> -->
      <v-menu offset-y v-if="isMobile">
        <template v-slot:activator="{ on, attrs }">
          <v-icon class="mr-10" v-bind="attrs" v-on="on"
            >mdi-dots-vertical</v-icon
          >
        </template>
        <v-list>
          <v-list-item>
            <user-menu :userInfo="userInfo"></user-menu>
          </v-list-item>
          <v-list-item>
            <tenant-selector :tenantItems="tenantItems"></tenant-selector>
          </v-list-item>
          <v-list-item>
            <language-selector></language-selector>
          </v-list-item>
          <v-list-item>
            <help></help>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </v-system-bar>
</template>

<script>
import ChangePassword from "../ChangePassword.vue";
import LoggedInUser from "../LoggedInUser.vue";
import ABtn from "../../wrapper-component/ABtn.vue";
import AMenu from "../../wrapper-component/AMenu.vue";
import TenantSelector from "./TenantSelector.vue";
import UserMenu from "./UserMenu.vue";
import LanguageSelector from "./LanguageSelector.vue";
import Help from "./Help.vue";
import JumpToMeeting from "@/components/agenda/JumpToMeeting.vue";
import GlobalSearchText from "../search/GlobalSearchText.vue";
export default {
  components: {
    ABtn,
    AMenu,
    LoggedInUser,
    ChangePassword,
    TenantSelector,
    UserMenu,
    LanguageSelector,
    Help,
    JumpToMeeting,
    GlobalSearchText,
  },
  name: "AppHeader",
  props: {
    tenantName: String,
    isOpenUserDialog: false,
    userInfo: Object,
    tenantItems: Array,
  },
  data() {
    return {
      activeUser: true,
      changePasswordDialog: false,
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    goHome() {
      if(this.$route.path === '/') {
        this.$router.go(0);
      }
      else {
        this.$router.push({ path: "/" });        
      }
    }
  }
};
</script>

<style scoped>
.board-logo:hover {
  cursor: pointer;
}

.v-text-field {
  max-width: 240px !important;
}

.v-text-field--filled.v-input--dense.v-text-field--single-line
  /deep/
  .v-input__slot {
  min-height: 34px !important;
  /* width: 240px !important; */
}

.v-text-field--filled.v-input--dense.v-text-field--single-line /deep/ .v-label {
  font-family: "Noto Sans JP" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 16px !important;
  color: var(--v-neutralGray-base) !important;
}
.v-text-field--filled {
  border-radius: 0 !important;
}

.v-system-bar .v-icon {
  margin-right: 0px;
}

.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #cccccc !important;
}
</style>